import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IPatient, IPatientSearchCriteria } from './_types';

const BASE_URL = '/portal-api/v1/patient';

// Create Patient
export const createPatient = async (data: any): Promise<IPatient | null> => {
  const response = await api().put(`${BASE_URL}/create`, data);
  return get(response, 'data', null);
};

// Update Patient
export const updatePatient = async (data: any): Promise<IPatient | null> => {
  const response = await api().post(`${BASE_URL}/update`, data);
  return get(response, 'data', null);
};

// Get Patient by ID
export const getPatient = async (id: number): Promise<IPatient | false> =>
  api()
    .get(`${BASE_URL}/get`, {
      params: { id },
    })
    .then((response) => get(response, 'data'))
    .catch((error) => false);

// Search Patients
export const searchPatients = async (
  searchCriteria: IPatientSearchCriteria,
): Promise<IPatient[] | false> =>
  api()
    .post(`${BASE_URL}/search`, searchCriteria)
    .then((response) => get(response, 'data'))
    .catch((error) => false);

// Delete Patient
export const deletePatient = async (id: number): Promise<boolean> =>
  api()
    .delete(`${BASE_URL}/delete`, { params: { id } })
    .then((response) => true)
    .catch((error) => false);
